import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const AlarmClockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M4.43431 1.43431L4.057 1.057C4.0205 1.02051 3.971 1 3.91938 1C2.30706 1 1.00001 2.30706 1 3.91938C1 3.971 1.0205 4.02051 1.057 4.057L1.43431 4.43431C1.63232 4.63232 1.73133 4.73133 1.84549 4.76842C1.94591 4.80105 2.05409 4.80105 2.15451 4.76842C2.26867 4.73133 2.36768 4.63232 2.56569 4.43431L4.43431 2.56569C4.63232 2.36768 4.73133 2.26867 4.76842 2.15451C4.80105 2.05409 4.80105 1.94591 4.76842 1.84549C4.73133 1.73133 4.63232 1.63232 4.43431 1.43431Z"
		></path>
		<path
			fill="currentColor"
			d="M3.50043 12.5C3.50043 12.5 3.1447 13.5672 3.03335 14.5014C3.00066 14.7756 3.22429 15 3.50043 15H4.29333C4.42594 15 4.55311 14.9473 4.64688 14.8536L5.50043 14L3.50043 12.5Z"
		></path>
		<path
			fill="currentColor"
			d="M12.5004 12.5C12.5004 12.5 12.8562 13.5672 12.9675 14.5014C13.0002 14.7756 12.7766 15 12.5004 15H11.7075C11.5749 15 11.4478 14.9473 11.354 14.8536L10.5004 14L12.5004 12.5Z"
		></path>
		<path
			fill="currentColor"
			d="M11.5657 1.43431L11.943 1.057C11.9795 1.02051 12.029 1 12.0806 1C13.6929 1 15 2.30706 15 3.91938C15 3.971 14.9795 4.02051 14.943 4.057L14.5657 4.43431C14.3677 4.63232 14.2687 4.73133 14.1545 4.76842C14.0541 4.80105 13.9459 4.80105 13.8455 4.76842C13.7313 4.73133 13.6323 4.63232 13.4343 4.43431L11.5657 2.56569C11.3677 2.36768 11.2687 2.26867 11.2316 2.15451C11.1989 2.05409 11.1989 1.94591 11.2316 1.84549C11.2687 1.73133 11.3677 1.63232 11.5657 1.43431Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5ZM10.6464 6.38292C10.8416 6.18765 10.8416 5.87107 10.6464 5.67581L10.324 5.35348C10.1288 5.15822 9.8122 5.15822 9.61693 5.35348L7.35348 7.61693C7.15822 7.8122 7.15822 8.12878 7.35348 8.32404L7.67581 8.64637C7.87107 8.84163 8.18765 8.84163 8.38292 8.64637L10.6464 6.38292Z"
		></path>
	</svg>
))
